import Swiper from 'swiper';

// Swiper Swatch slider
const init = function(swiperId) {
  const swatchSwiper = new Swiper(swiperId, {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    grabCursor: true,
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.js-swiper-button-next',
      prevEl: '.js-swiper-button-prev',
    },
  });
};

export default {
  init,
};
